import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { HeaderInfo } from "../../types";
import CloseIcon from "@mui/icons-material/Close";

const HeaderTab = ({
  header,
  onTabClick,
  onTabClear,
  selectedTab,
}: {
  header: HeaderInfo;
  onTabClick: (header: HeaderInfo) => void;
  onTabClear: (header: HeaderInfo) => void;
  selectedTab: string;
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  
  const isActive = selectedTab === header.key;
  const isDisabled = header.value === 0 || (selectedTab && !isActive);

  // Set theme-based styles
  const boxStyles = {
    backgroundColor: isActive
      ? isDark
        ? "#525252"  // Dark background for active tab in dark mode
        : "#f5f5f5"  // Light background for active tab in light mode
      : isDark
      ? "#3c3c3c"  // Dark background for inactive tab in dark mode
      : "#e0e0e0", // Light background for inactive tab in light mode
    color: isActive ? (isDark ? "#fff" : "#000") : isDark ? "#ccc" : "#333",
    cursor: isDisabled ? "not-allowed" : "pointer",
    opacity: isDisabled ? 0.5 : 1,
  };

  const textStyles = {
    fontWeight: 600,
    fontSize: "12px",
    color: isActive ? (isDark ? "#fff" : "#000") : isDark ? "#ccc" : "#333",
  };

  // Adjusted button styles for dark mode
  const buttonStyles = {
    backgroundColor: isDark ? "transparent" : "#f5f5f5",  // Transparent in dark mode
    color: isDark ? "#ccc" : "#333",  // Lighter color for dark mode
    "&:hover": {
      backgroundColor: isDark ? "#444" : "#e0e0e0",  // Darker hover in dark mode, lighter in light mode
    },
  };

  return (
    <Box
      key={header.key}
      className={`search-results-btn${isActive ? " active" : ""}${isDisabled ? " noAction" : ""}`}
      sx={boxStyles}
    >
      <Typography
        onClick={() => header.value !== 0 && onTabClick(header)}
        variant="body2"
        sx={textStyles}
        aria-label={`Tab ${header.key} with value ${header.value}`}
      >
        {header?.key} ({header?.value})
      </Typography>

      {isActive && (
        <IconButton
          className="clear"
          onClick={() => onTabClear(header)}
          sx={{ ...buttonStyles, marginLeft: '5px' }}
          aria-label={`Close ${header.key} tab`}
        >
          <CloseIcon fontSize="small" sx={{color:'#3A2ADA', width:'12px', height:'12px'}}/>
        </IconButton>
      )}
    </Box>
  );
};

export default HeaderTab;
